export default {
  title: 'Contact us',
  text1: 'How can we help?',
  text2: '(The handling of the data Will be strictly confidential)',
  phone: 'Phone number: 2338-0206',
  email: 'E-mail: administracion@romanyroman.com',
  address: 'Address: 6ta. Avenida 0-60 Gran Centro Comercial Zona 4, Torre Profesional I, Oficina 911',
  request: {
    name: 'Full Name',
    phone: 'Phone number (optional)',
    email: 'Email',
    service: 'Required Service',
    message: 'Message',
  },
  services: [
    {title: 'Consulting and Consulting'},
    {title: 'Audit'},
    {title: 'Sworn Translation'},
    {title: 'Seminaries'},
    {title: 'Recruitment'},
    {title: 'Outsourcing'},
    {title: 'Technology and Systems'},
    {title: 'Taxes and Legal'},
  ]
}



// WEBPACK FOOTER //
// ./src/text/en/contact.js